import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AiRoutingModule } from './ai-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AiRoutingModule
  ]
})
export class AiModule { }
